import React from 'react';
import { AspectRatio } from 'react-aspect-ratio';
import 'react-aspect-ratio/aspect-ratio.css';

const WebAspectRatio = ({ ratio = '1', children }) => {
    return <AspectRatio ratio={ratio}>{children}</AspectRatio>;
};

export default WebAspectRatio;
